import { FunctionComponent, PropsWithChildren, useContext, useMemo } from 'react';

import { WidgetButtonEntry, WidgetEntry, WidgetEntryType } from '@vestico/model';

import { InternationalizationLazyLoader } from './InternationalizationLoaderLazy';
import { WidgetEntryContext } from './WidgetEntryContext';
import { DEFAULT_MAIN_BUTTON_INJECTION_ID, MOBILE_SDK_MAIN_BUTTON_INJECTION_ID } from './WidgetEntryContextStaticElements';
import { ConfigContext } from './WidgetEventsManager';

export interface WidgetEntryHandlerProps extends PropsWithChildren {
  entries: WidgetEntry[] | undefined;
}

export const WidgetEntryHandler: FunctionComponent<WidgetEntryHandlerProps> = (props) => {
  const { entries, children } = props;
  const { isSDK } = useContext(ConfigContext);

  if (entries?.findIndex((e) => e.type === WidgetEntryType.button || e.type === WidgetEntryType.link) === -1 && !isSDK) {
    const buttonEntry: WidgetButtonEntry = {
      id: DEFAULT_MAIN_BUTTON_INJECTION_ID,
      type: WidgetEntryType.button,
      enabled: true,
      injectionScript: '',
      cssClasses:
        'Button Button--primary Button--full btn btn--to-secondary btn--full btn--secondary btn--secondary-accent button vestico-widget-default',
      cssStyle: '',
      isThemeInserted: false,
      location: 'pdps',
    };
    entries.push(buttonEntry);
  }

  if (isSDK) {
    const buttonEntry: WidgetButtonEntry = {
      id: MOBILE_SDK_MAIN_BUTTON_INJECTION_ID,
      type: WidgetEntryType.button,
      enabled: true,
      injectionScript: '',
      cssClasses: '',
      cssStyle: '',
      isThemeInserted: false,
      location: 'pdps',
    };
    entries?.push(buttonEntry);
  }

  const { contextResults } = useMemo(() => {
    if (!entries) {
      return { contextResults: undefined, hasCarouselContext: false };
    }

    const contexts = [];

    for (const entry of entries) {
      const entryContext = <WidgetEntryContext key={entry.id} entry={entry} />;
      contexts.push(entryContext);
    }

    return { contextResults: contexts };
  }, [entries]);

  return (
    <InternationalizationLazyLoader>
      {contextResults}
      {children}
    </InternationalizationLazyLoader>
  );
};
